import { getSupabase } from '@/lib/supabase'

const STORAGE_KEY = 'mtp.activeWorkspaceId'
let cached: string | null = null

export function clearActiveWorkspace(): void {
  cached = null
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch {
    /* storage unavailable (private mode) — ignore */
  }
}

export function getActiveWorkspaceId(): string | null {
  if (cached) return cached
  try {
    cached = localStorage.getItem(STORAGE_KEY)
  } catch {
    /* storage unavailable — ignore */
  }
  return cached
}

/**
 * Ensure the signed-in owner has a workspace. Calls the idempotent
 * `provision_workspace` RPC (creates the workspace + owner membership and seeds the
 * four starter categories once, or returns the existing workspace id).
 */
export async function ensureWorkspace(name = 'My Shop'): Promise<string> {
  const existing = getActiveWorkspaceId()
  if (existing) return existing

  const { data, error } = await getSupabase().rpc('provision_workspace', { p_name: name })
  if (error) throw new Error(error.message)
  if (typeof data !== 'string' || data.length === 0) {
    throw new Error('provision_workspace returned no workspace id')
  }

  cached = data
  try {
    localStorage.setItem(STORAGE_KEY, data)
  } catch {
    /* storage unavailable — ignore */
  }
  return data
}
